module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie TableCell must be inside a Nessie TableRow. See Table component for more info.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;TableCell columnTitle=&quot;column title&quot;&gt;\n    cell contents\n&lt;/TableCell&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TableCell/README.md
// module id = 396
// module chunks = 0